import { useState } from 'react';
import { TargetCatalogEntryInfo } from 'ais-facade-api/api';
import { useAppDispatch } from 'app/store/store';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { setFindAton, setFindVessel } from 'app/utils/selectedTargetsSlice';
import { Button, Dropdown, DropDownItem } from 'app/components';

interface FleetActionCellI {
  vessel: TargetCatalogEntryInfo;
  setModalMmsi: (mmsi: number) => void;
}

export const FleetActionCell = ({ vessel, setModalMmsi }: FleetActionCellI) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);

  const canBeShown = typeof vessel?.position?.latitude === 'number' && typeof vessel.position.longitude === 'number';
  const showVessel = () => {
    const isAton = vessel.registryData?.specialType && vessel.registryData.specialType === 'ATON';

    if (isAton) {
      dispatch(setFindAton(vessel));
    } else dispatch(setFindVessel(vessel));
    navigate('/mapview');
  }

  const openNoteModal = () => {
    if (typeof vessel.mmsi === 'number') setModalMmsi(vessel.mmsi);
  }

  return (
    <>
      <Button
        variant='icon-only'
        iconName='more-icon'
        iconSize="13px"
        aria-expanded={dropdown}
        onClick={() => setDropdown((prev) => !prev)}
      />
      <Dropdown
        dropdown={dropdown}
        onClickOutside={() => {
          setDropdown(false);
        }}
      >
        <DropDownItem>
          <button
            aria-disabled={!canBeShown}
            disabled={!canBeShown}
            onClick={showVessel}
          >
            {t('ShowOnMap')}
          </button>
        </DropDownItem>
        <DropDownItem>
          <button
            onClick={openNoteModal}
          >
            {t('Notes')}
          </button>
        </DropDownItem>
      </Dropdown>
    </>
  );
};
